module.exports = {
  "country": "GR",
  "artist": "Sakis Rouvas",
  "song": "Shake It",
  "year": "2004",
  "place": "3",
  "spotify": "2xagoLNhrbVA2fpOkxs2Ze"
};